<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="6">
        <base-material-card color="indigo"
                            icon="mdi-content-copy"
                            title="Create consignment stock"
                            class="px-5 py-3">
          <v-form class="mt-5" @submit.prevent="create">
            <v-autocomplete v-model="consignmentStock.customer.id"
                            label="Customer"
                            :items="customers"
                            :item-text="customerText"
                            item-value="id"
                            prepend-icon="mdi-account"
                            autocomplete="off"
                            name="customer"
                            data-vv-as="Customer"
                            v-validate="validators.customer"
                            :error="getError('customer')" />
            <v-autocomplete v-model="preDefinedStock"
                            label="Predefined stocks"
                            :items="predefinedStocks"
                            item-text="name"
                            return-object
                            prepend-icon="mdi-database-search"
                            autocomplete="off" />
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-menu v-model="startCalendar"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="consignmentStock.start"
                                  label="Start"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  name="start date"
                                  v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="consignmentStock.start" @input="startCalendar = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="6" md="4">
                <v-menu v-model="endCalendar"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="consignmentStock.end"
                                  label="End"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="consignmentStock.end" @input="endCalendar = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
            <v-expand-transition>
              <v-list v-if="preDefinedStock.id > 0" class>
                <v-list-item v-for="(pq, i) in preDefinedStock.productQuantities" :key="i">
                  <v-list-item-content>
                    <v-row>
                      <v-col>
                        <v-list-item-title>Product</v-list-item-title>
                        <v-list-item-subtitle v-text="pq.product.name"></v-list-item-subtitle>
                      </v-col>

                      <v-col>
                        <v-list-item-title>Quantity</v-list-item-title>
                        <v-list-item-subtitle v-text="pq.quantity"></v-list-item-subtitle>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-expand-transition>
            <br />
            <v-row justify="center">
              <v-card-actions class="pl-0">
                <v-btn color="success" min-width="100" @click="goBack()">Return</v-btn>
              </v-card-actions>
              <v-card-actions class="pl-0">
                <v-btn type="submit" color="success" min-width="100">Submit</v-btn>
              </v-card-actions>
            </v-row>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
    <div class="text-center ma-2">
      <v-snackbar v-model="snackbar" :color="snackColor">
        {{ message }}
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
  import router from "../../../router";
  import axios from "../../../utils/axios";
  import {
    getErrorMessageFromException,
    getErrorMessageFromValidation
  } from "../../../helpers/errorHelper";

  export default {
    name: "ConsignmentStocksCreate",
    data: () => ({
      consignmentStock: {
        id: 0,
        errorMessage: String,
        totalValue: 0,
        totalInValue: 0,
        start: new Date().toISOString().substr(0, 10),
        end: new Date().toISOString().substr(0, 10),
        status: 0,
        customer: {
          id: null,
          name: String
        },
        items: []
      },
      validators: {
        customer: {
          required: true
        }
      },
      preDefinedStock: {
        id: -1,
        name: String,
        productQuantities: [
          {
            id: Number,
            product: {
              name: String,
              productDescription: String,
              articleNumber: String,
              id: Number
            },
            quantity: Number
          }
        ],
        totalValue: Number,
        totalInValue: Number
      },

      customers: [],
      predefinedStocks: [],
      products: [],

      startCalendar: false,
      endCalendar: false,

      snackbar: false,
      message: "",
      snackColor: "error"
    }),
    watch: {
      preDefinedStock(newStock, oldStock) {
        this.consignmentStock.items = newStock.productQuantities;
      }
    },
    created() {
      this.predefinedStocks.push({ id: 0, name: "None" });
      this.getCustomers();
      this.getPredefinedStocks();
    },
    methods: {
      async getCustomers() {
        let loader = this.$loading.show();
        try {
          var result = await axios.get("/Customer");
          if (result) {
            this.customers = result.data;
          } else {
            throw "Unknown error";
          }
        } catch (exception) {
          this.message = getErrorMessageFromException(exception);
          this.snackbar = true;
        } finally {
          loader.hide();
        }
      },

      async getPredefinedStocks() {
        let loader = this.$loading.show();
        try {
          var result = await axios.get("/PreDefinedConsignmentStock");
          if (result) {
            this.predefinedStocks.push(...result.data);
          } else {
            throw "Unknown error";
          }
        } catch (exception) {
          this.message = getErrorMessageFromException(exception);
          this.snackbar = true;
        } finally {
          loader.hide();
        }
      },

      async create() {
        this.$validator.validateAll().then(async isValid => {
          if (isValid) {
            let loader = this.$loading.show();
            try {
              var result = await axios.post(
                "/ConsignmentStock",
                this.consignmentStock
              );
              if (result) {
                this.goBack();
              } else {
                throw "Unknown error";
              }
            } catch (exception) {
              this.message = getErrorMessageFromException(exception);
              this.snackbar = true;
            } finally {
              loader.hide();
            }
          } else {
            this.message = getErrorMessageFromValidation(this.errors.items);
            this.snackbar = true;
          }
        });
      },

      getError(fieldName) {
        if (this.errors.first(fieldName) !== undefined) {
          return true;
        }
        return false;
      },

      goBack() {
        this.$router.go(-1);
      },

      customerText: customer => customer.name + " — " + customer.customerId
    }
  };
</script>

<style>
</style>
